import cashflowViewConsts from '../../../constants/cashflow-view';

const ENRICHMENT_INPUT_TYPES = {
  TRANSACTION_ID: 'transactionId',
  BUSINESS_NAME: 'businessName',
};

const categoryToVariant = {
  recurring: 'primary',
  variable: 'warning',
  fixed: 'danger',
  'variable-income': 'success',
  'fixed-income': 'success',
  'excluded-income': 'neutral',
  'excluded-expense': 'neutral',
};

function getRelevantRecurringCategories(categories, availableCashflowCategories, recurringExpenses) {
  if (!_.includes(availableCashflowCategories, cashflowViewConsts.CASHFLOW_CATEGORIES.RECURRING)) {
    return [];
  }
  const categoriesInCashflow = _.map(recurringExpenses, expense => expense.expenseCategory);
  const recurringCategories = _.filter(categories, category => _.includes(categoriesInCashflow, category.expense));
  const economyCategory = _.find(categories, { categoryName: cashflowViewConsts.CATEGORY_NAMES.RECURRING_ECONOMY });
  return [economyCategory, ...recurringCategories];
}

function getNonRecurringCategories(categories, availableCashflowCategories) {
  const nonRecurringCashflowCategories = _.without(availableCashflowCategories, cashflowViewConsts.CASHFLOW_CATEGORIES.RECURRING);
  return _.filter(categories, category => _.includes(nonRecurringCashflowCategories, category.cashflowCategory));
}

function orderCategories(categories) {
  const precedence = [
    cashflowViewConsts.CASHFLOW_CATEGORIES.VARIABLE,
    cashflowViewConsts.CASHFLOW_CATEGORIES.RECURRING,
    cashflowViewConsts.CASHFLOW_CATEGORIES.FIXED,
    cashflowViewConsts.CASHFLOW_CATEGORIES.EXCLUDED_EXPENSE,
    cashflowViewConsts.CASHFLOW_CATEGORIES.VARIABLE_INCOME,
    cashflowViewConsts.CASHFLOW_CATEGORIES.FIXED_INCOME,
    cashflowViewConsts.CASHFLOW_CATEGORIES.EXCLUDED_INCOME,
  ];
  return _.sortBy(categories, c => _.indexOf(precedence, c.cashflowCategory));
}

const state = {
  categoryRuleType: null,
  recurringExpenses: null,
  transaction: null,
  originalCategoryName: null,
  selectedCategoryName: null,
};

const getters = {
  categoriesWithStyle: () => _.map(cashflowViewConsts.CATEGORIES, category => {
    const style = categoryToVariant[category.cashflowCategory];
    return _.assign({ style }, category);
  }),
  ENRICHMENT_INPUT_TYPES: () => ENRICHMENT_INPUT_TYPES,
  categoryToVariant: () => categoryToVariant,
  isIncomeCategory: state =>
    _.includes(
      [
        cashflowViewConsts.CATEGORY_NAMES.VARIABLE_INCOME,
        cashflowViewConsts.CATEGORY_NAMES.FIXED_INCOME,
        cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_INCOME,
      ],
      state.originalCategoryName,
    ),
  incomeOrExpense: (state, getters) => (getters.isIncomeCategory ? 'הכנסה' : 'הוצאה'),
  originalCategory: (state, getters) => _.find(getters.categoriesWithStyle, { categoryName: state.originalCategoryName }),
  selectedCategory: (state, getters) => _.find(getters.categoriesWithStyle, { categoryName: state.selectedCategoryName }),
  originalCashflowCategory: (state, getters) => getters.originalCategory.cashflowCategory,
  availableCashflowCategories: (state, getters) => cashflowViewConsts.AVAILABLE_CASHFLOW_CATEGORIES[getters.originalCashflowCategory],
  availableCategories: (state, getters) => {
    const nonRecurringCategories = getNonRecurringCategories(getters.categoriesWithStyle, getters.availableCashflowCategories);
    const recurringCategories = getRelevantRecurringCategories(
      getters.categoriesWithStyle,
      getters.availableCashflowCategories,
      state.recurringExpenses,
    );
    return orderCategories([...nonRecurringCategories, ...recurringCategories]);
  },
};

const actions = {
  startEditingTransaction({ state, getters, commit, dispatch, rootState }, { transaction, categoryName }) {
    commit('setTransaction', transaction);
    commit('setOriginalCategoryName', categoryName);
    commit('setSelectedCategoryName', categoryName);
  },
};

const mutations = {
  setSelectedCategoryName(state, selectedCategoryName) {
    state.selectedCategoryName = selectedCategoryName; // eslint-disable-line
  },
  setRecurringExpenses(state, recurringExpenses) {
    state.recurringExpenses = recurringExpenses; // eslint-disable-line
  },
  setTransaction(state, transaction) {
    state.transaction = transaction; // eslint-disable-line
  },
  setCategoryRuleType(state, categoryRuleType) {
    state.categoryRuleType = categoryRuleType; // eslint-disable-line
  },
  setOriginalCategoryName(state, originalCategoryName) {
    state.originalCategoryName = originalCategoryName; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/cashflow-app/editTransaction.js